import { render } from "./DropdownCeilings.vue?vue&type=template&id=eb5d8b7e"
import script from "./DropdownCeilings.vue?vue&type=script&lang=ts"
export * from "./DropdownCeilings.vue?vue&type=script&lang=ts"
script.render = render

export default script